import swall from 'sweetalert'
import storage from '@/commons/config/storage.config'

const alert = {
  confirmation (callback, confirmationText = '') {
    swall({
      text: confirmationText === '' ? 'Apakah anda yakin ingin menghapus data ini?' : confirmationText,
      buttons: ['Tidak', 'Ya']
    }).then(willDelete => {
      if (willDelete) {
        if (callback) callback()
      }
    })
  },

  confirmSwitch (callback, confirmationTitle = '', confirmationText = '', status = '') {
    swall({
      title: status + 'kan ' + confirmationTitle,
      text: 'Apakah anda yakin ingin ' + confirmationText + ' ' + confirmationTitle + ' ini?',
      buttons: {
        cancel: 'Tidak',
        confirm: {
          text: 'Yakin',
          className: 'confirm-button-red'
        }
      }
    }).then(willDelete => {
      if (willDelete) {
        if (callback) callback()
      }
    })
  },

  // confirmSwitch (callYes, callNo) {
  //   swall({
  //     text: 'Yakin Ingin Mengubah Data?',
  //     buttons: ['Tidak', 'Ya']
  //   }).then(willDelete => {
  //     if (willDelete) {
  //       if (callYes) callYes()
  //     } else {
  //       if (callNo) callNo()
  //     }
  //   })
  // },

  confirmation2 (callback, confirmationText = '', stop) {
    swall({
      text: confirmationText === '' ? 'Apakah anda yakin ingin menghapus data ini?' : confirmationText,
      buttons: ['Tidak', 'Ya']
    }).then(result => {
      if (result) {
        if (callback) {
          callback()
        } else {
          stop()
        }
      }
    })
  },

  confirmation3 (callback, callback2, confirmationHeader, confirmationText) {
    swall({
      title: confirmationHeader,
      text: confirmationText,
      icon: 'warning',
      buttons: {
        notconfirm: {
          text: 'Tidak',
          value: false,
          visible: true,
          className: 'swal-button--cancel'
        },
        confirm: {
          text: 'Ya',
          value: true,
          visible: true
        }
      },
      closeOnClickOutside: true,
      closeOnEsc: true,
      dangerMode: true
    }).then(function (isConfirm) {
      if (isConfirm) {
        if (callback) callback()
      } else if (isConfirm === false) {
        if (callback2) callback2()
      }
    })
  },

  success (successText = '', callback) {
    swall({
      icon: 'success',
      // title: 'Berhasil',
      text: successText === '' ? 'Data berhasil disimpan!' : successText,
      button: true
    }).then(result => {
      if (result) {
        if (callback) callback()
      }
    })
  },

  successrubah (successText = '', callback) {
    swall({
      icon: 'success',
      text: successText === '' ? 'Data berhasil diubah!' : successText,
      button: true
    }).then(result => {
      if (result) {
        if (callback) callback()
      }
    })
  },

  successhapus (successText = '', callback) {
    swall({
      icon: 'success',
      text: successText === '' ? 'Data berhasil dihapus!' : successText,
      button: true
    }).then(result => {
      if (result) {
        if (callback) callback()
      }
    })
  },

  custom (status, successText = '', callback) {
    swall({
      icon: status === 200 ? 'success' : 'warning',
      title: status === 200 ? 'Berhasil' : 'warning',
      text: successText === '' ? '' : successText,
      button: true
    }).then(result => {
      if (result) {
        if (callback) callback()
      }
    })
  },

  failed (failText = '', callback) {
    swall({
      icon: 'error',
      title: 'Gagal',
      text: failText === '' ? 'Terjadi Kesalahan, Silahkan Coba Kembali' : failText,
      button: true
    }).then(result => {
      if (result) {
        if (callback) callback()
      }
    })
  },

  breaksession (failText = '') {
    swall({
      icon: 'warning',
      text: failText === '' ? 'Sesi anda telah berakhir' : failText
    }).then((result) => {
      if (result) {
        storage.clearSession()
        location.replace('/redirect-sso')
      }
    })
  },

  warning (failText = '', callback) {
    swall({
      icon: 'warning',
      title: 'Perhatian',
      text: failText === '' ? 'Terjadi Kesalahan, Silahkan Coba Kembali' : failText,
      button: true
    }).then(result => {
      if (result) {
        if (callback) callback()
      }
    })
  }
}

export default alert
